<template>
  <LayoutSection
    :title="$texts('publications', 'Publikationen')"
    padding
    class="paragraph--padded"
  >
    <SearchTeaserList
      v-slot="{ hit }"
      endpoint="publications"
      :size="count"
      :reference-facets="{
        organization,
      }"
      :query-filters="{
        topic,
      }"
      list-class="grid md:grid-cols-3 gap-25 mb-30"
      :show-more="{
        route: 'publications',
        label: $texts('allPublications', 'Alle Publikationen'),
      }"
      :no-results-text="
        $texts(
          'publicationList.noPublicationsFoundWithSelectedFilters',
          'Es wurden keine Publikationen mit den ausgewählten Filtern gefunden.',
        )
      "
    >
      <CommerceProductPublicationTeaser
        :url="hit.url"
        :title="hit.title"
        :organisation-label="hit.organization"
        :teaser-image="hit.image"
      />
    </SearchTeaserList>
  </LayoutSection>
</template>

<script lang="ts" setup>
import type { ParagraphPublicationListFragment } from '#graphql-operations'

defineBlokkli({
  bundle: 'publication_list',
  globalOptions: ['bkVisibleLanguages'],
  chunkName: 'rare',
})

defineProps<{
  count?: ParagraphPublicationListFragment['count']
  topic?: ParagraphPublicationListFragment['topic']
  organization?: ParagraphPublicationListFragment['organization']
}>()

defineOptions({
  name: 'ParagraphPublicationList',
})

useCDNHeaders((v) => v.addTags(['nuxt:content:publication']))
</script>
